import React, { useState } from 'react';
import { map } from 'lodash';
import { Main, Button, FlexContainer, Row, Text, Column, Icon, Divider, FormInput } from '../../common';
import { Tooltip } from 'antd';
import DrawerFormPoll from './DrawerFormPoll/DrawerFormPoll';

const actionIcons = () => {
    return [
        { name: 'export', toolTip: 'Editar' },
        { name: 'darkstore', toolTip: 'Obligatoriedad' },
        { name: 'required', toolTip: 'Duplicar' },
        { name: 'new-trash', toolTip: 'Eliminar' },
        { name: 'pencil-edit', toolTip: 'Exportar CSV' }
    ];
};

const ShopperTraining = () => {
    const [drawerPoll, setDrawerPoll] = useState({ visible: false, isCreate: false, pollSelected: {} });

    const handleDrawerFromCreate = () => {
        setDrawerPoll({ visible: true });
    };

    const onCloseDrawerPoll = () => {
        setDrawerPoll({ visible: false });
    };

    return <Main withFooter background='f4f4f4'>
        <FlexContainer padding={23}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='25px 13px'
                noWrap
                backgroundColor='white'
                justify='flex-end'
                align='center'
            >
                <Button type='primary' onClick={handleDrawerFromCreate} width={200} style={{ alignItems: 'center' }}>
                    <Icon name='plus' color='white' style={{ margin: '3px 5px' }} />
                    Agregar categoría
                </Button>
            </Row>
        </FlexContainer>
        <FlexContainer gap={10} style={{ padding: '0px 25px 25px' }} direction='column'>
            <Row
                borderRadius={3}
                backgroundColor='white'
                height={64}
                align='center'
                padding='0px 13px'
                gap={20}
            >
                <Row justify='flex-start'>
                    <Text text='Picking' />
                </Row>
                <Row justify='center'>
                    <Column justify='center' align='center'>
                        <Text text='25/07/2022' strong />
                        <Text text='Fecha de creación' />
                    </Column>
                </Row>
                <Column>
                    <Row justify='center'>
                        <Text text='1' strong />
                        <Icon name='file' size={16} />
                    </Row>
                    <Row justify='center'>
                        <Text text='Archivos' />
                    </Row>
                </Column>
                <Row gap={25} justify='flex-end'>
                    {map(actionIcons(), ({ name, toolTip }, index) => {
                        return (<Tooltip placement='top' title={toolTip} key={index} autoAdjustOverflow={false}>
                            <a><Icon name={name} color='#1fa02e' size={23} pointer /></a>
                        </Tooltip>);
                    })}
                </Row>
            </Row>
            <Row
                borderRadius={3}
                backgroundColor='white'
                align='center'
                padding='13px 13px'
            >
                <Row align='center' gap={20}>
                    <Row justify='flex-start'>
                        <FormInput width={350} />
                    </Row>
                    <Row justify='center'>
                        <Column justify='center' align='center'>
                            <Text text='25/07/2022' strong />
                            <Text text='Fecha de creación' />
                        </Column>
                    </Row>
                    <Column>
                        <Row justify='center'>
                            <Text text='1' strong />
                            <Icon name='file' size={16} />
                        </Row>
                        <Row justify='center'>
                            <Text text='Archivos' />
                        </Row>
                    </Column>
                    <Row gap={25} justify='flex-end'>
                        {map(actionIcons(), ({ name, action, toolTip }, index) => {
                            return (<Tooltip placement='top' title={toolTip} key={index} autoAdjustOverflow={false}>
                                <a><Icon name={name === 'pencil-edit' ? 'close' : name} color='#1fa02e' size={23} pointer /></a>
                            </Tooltip>);
                        })}
                    </Row>
                </Row>
                <Divider style={{ paddingBotton: 10 }} />
                <Row gap={25}>
                    <Row>
                        <Column>
                            <Button type='primary' width={200}>
                                Crear test evaluativo
                            </Button>
                            <Divider />
                            <Row justify='space-between' align='center'>
                                <Row gap={5}>
                                    <Row justify='flex-end' align='center'>
                                        <Icon name='file' size={30} color='#1fa02e' />
                                    </Row>
                                    <Column align='flex-start'>
                                        <Text text='Documentos' strong />
                                        <Text text='PDF,PPT' color='#666666' />
                                    </Column>
                                </Row>
                                <Row gap={4}>
                                    <Row justify='flex-end' align='center'>
                                        <Icon name='camara' size={30} color='#1fa02e' />
                                    </Row>
                                    <Column align='flex-start'>
                                        <Text text='Videos' strong />
                                        <Text text='MP4, MOV,AVI' color='#666666' />
                                    </Column>
                                </Row>
                            </Row>
                            <Column
                                align='center'
                                style={{
                                    background: '#FFFFFF',
                                    border: '1px dashed rgba(0, 0, 0, 0.15)',
                                    borderRadius: 3,
                                    height: 178,
                                    gap: 5,
                                    padding: 33
                                }}
                            >
                                <Icon name='upload-file' size={25} color='#1fa02e' />
                                <Text text='Arrastrar archivo para cargar' strong />
                                <Text text='0' />
                                <Row>
                                    <Button width={200}>
                                        Cargar desde mi equipo
                                    </Button>
                                </Row>
                            </Column>
                        </Column>
                    </Row>
                    <Row padding={10}
                        style={{
                            background: '#FFFFFF',
                            boxShadow: '1px 0px 8px 1px rgba(0, 0, 0, 0.15)',
                            borderRadius: 3
                        }}
                    >
                        <Column>
                            <Text text='Archivos' strong />
                            <Divider />
                            <div>
                                <Row gap={10} align='center'>
                                    <Icon name='file' size={20} />
                                    <Column>
                                        <Text text='Preparacion.pdf' />
                                        <div style={{
                                            background: '#E2E2E2',
                                            borderRadius: 20,
                                            height: 6
                                        }} />
                                        <Row justify='space-between'>
                                            <Text text='0 KB de 3MB' size={8} color='#666666' />
                                            <Text text='0%' size={8} color='#666666' />
                                        </Row>
                                    </Column>
                                    <Row justify='flex-end' gap={10}>
                                        <Icon name='pencil-edit' size={20} color='#1fa02e' />
                                        <Icon name='new-trash' size={20} color='#1fa02e' />
                                    </Row>
                                </Row>
                            </div>
                            <Divider />
                        </Column>
                    </Row>
                </Row>
            </Row>
        </FlexContainer>
        {<DrawerFormPoll
            visible={drawerPoll.visible}
            onClose={onCloseDrawerPoll}
            pollSelected={drawerPoll.pollSelected}
            isCreate={drawerPoll.isCreate}
        />}
    </Main>;
};

export default ShopperTraining;
